export const PRIMARY_LANGUAGE = 'hs_main_user_language_skill';
export const SECONDARY_LANGUAGE = 'hs_secondary_user_language_skills';
export const CUSTOM_SKILL = 'hs_uncategorized_skills';
export const knownCategories = new Set([PRIMARY_LANGUAGE, SECONDARY_LANGUAGE, CUSTOM_SKILL]);